import { CategoryLink } from '@/sanity/fetchCategories';
import { URL_PATH_CATEGORY } from '@/shared/constants';
import HIHLink from './Link';
import styles from './Tag.module.scss';

interface TagProps {
  label: string;
  href?: string;
  size?: 'sm' | 'md';
  variant?: 'light' | 'dark';
  className?: string;
  hasHoverEffect?: boolean;
}

export const CategoryTag = ({
  category,
  size = 'sm',
}: {
  category: CategoryLink;
  size?: 'sm' | 'md';
}) => {
  return (
    <Tag
      label={category.name}
      href={`/${URL_PATH_CATEGORY}/${category.slug.current}`}
      size={size}
    />
  );
};

export default function Tag({
  label,
  href,
  size = 'md',
  variant = 'dark',
  className,
  hasHoverEffect = true,
}: TagProps) {
  const tagClass = [
    styles.tag,
    styles[size],
    styles[variant],
    hasHoverEffect ? styles.hoverable : undefined,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const content = <span className={styles.label}>{label}</span>;

  if (href !== undefined) {
    return (
      <a href={href}>
        <div className={tagClass}>{content}</div>
      </a>
    );
  } else {
    return <div className={tagClass}>{content}</div>;
  }
}
